import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { collection } from '@/services/collection';
import { debounce } from 'lodash';

declare global {
    interface Window {
        /* eslint-disable */
		_swat?: any;
		SwymPageData?: any;
		SwymCallbacks: any;
		/* eslint-enable */
    }
}

@Component
export class CollectionMain extends ThemeComponent {
    @Prop collection !: string;
    @Ref({required: false}) productGrid!: HTMLDivElement;
    @Ref({required: false}) content!: HTMLDivElement;
    @Ref() paginationIntersection!: HTMLDivElement;

    private pages!:number;
    private page!:number;
    private contentObj: string[] = [];

    init() {
        this.page = +(this.productGrid.dataset.page as string);
        this.pages = +(this.productGrid.dataset.pages as string);

        if (this.pages == 1) { return; }
        this.getAllPages();
        this.observeScroll();
    }

    private observeScroll() {
        const observer = new IntersectionObserver((entries) => {
            if (this.page > this.pages) { return; }
            for (const entry of entries) {
                if (entry.target.classList.contains('collection-main__intersection')) {
                    const newGrid = this.contentObj[this.page + 1];
                    this.content.innerHTML = this.content.innerHTML + (newGrid?newGrid:'');
                    this.handelWishlist();
                    observer.disconnect;
                    this.page++;
                }
            }
        }, {rootMargin: "0px 0px 200px 0px"});

        // Observe the element with the class "collection-main__intersection"
        if (this.paginationIntersection) {
            window.addEventListener('scroll', debounce(()=> {
                const intersection = document.querySelector('.collection-main__intersection') as HTMLElement;
                observer.observe(intersection);
            }, 300));
        }
    }

    private getAllPages() {
        for (let i = this.page; i < this.pages + 1; i++) {
            this.getNextBatchOfProducts(`${this.collection}?page=${i + 1}`, (i + 1)).catch((event: unknown | null) => {
                if (event instanceof Error) {
                    this.$log.info(event.message);
                }
            });
        }
    }

    async getNextBatchOfProducts(url:string, page:number) {
        // Make request for the next URL
        const response = await collection
            .render(['collection_layout'], url);

        const collectionMainDom = new DOMParser().parseFromString(response['collection_layout'], 'text/html');

        // Get new elements from response data and replace components
        const collectionMainProducts =
        collectionMainDom.querySelector('[data-ref="productGrid"]') as HTMLDivElement;

        this.contentObj[page] = collectionMainProducts.outerHTML;
    }

    private handelWishlist() {
        /* eslint-disable */
		if (window._swat) {
			window._swat.initializeActionButtons('.collection-main__content');

		} else {
			window.SwymCallbacks = window.SwymCallbacks || [];

			window.SwymCallbacks.push(() => {
				window._swat.initializeActionButtons('.collection-main__content');
			});
		}
		/* eslint-enable */
    }
}
